import { render, staticRenderFns } from "./ProcessDeterminationDocument.vue?vue&type=template&id=21da1131&scoped=true"
import script from "./ProcessDeterminationDocument.vue?vue&type=script&lang=js"
export * from "./ProcessDeterminationDocument.vue?vue&type=script&lang=js"
import style0 from "./ProcessDeterminationDocument.vue?vue&type=style&index=0&id=21da1131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da1131",
  null
  
)

export default component.exports